import { render, staticRenderFns } from "./liveDetail.vue?vue&type=template&id=4597b5d3"
import script from "./liveDetail.vue?vue&type=script&lang=js"
export * from "./liveDetail.vue?vue&type=script&lang=js"
import style0 from "./liveDetail.vue?vue&type=style&index=0&id=4597b5d3&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports